import { Money } from "models/money";

export function getExcelData(data) {
  let rows = [];
  let count = 1;
  data.forEach((elem) => {
    var _known = {
      Numero: count,
      Empresa: elem.company,
      Ventas: Money(elem.total),
    };
    Object.keys(elem.sectors).forEach((sectorKey) => {
      const keyValue = elem.sectors[sectorKey].name;
      const saleValue = Money(elem.sectors[sectorKey].sale);
      _known[keyValue] = saleValue;
    });

    rows.push(_known);
    count++;
  });
  return rows;
}
